export var LengthUnits;
(function (LengthUnits) {
    LengthUnits["FEET"] = "Feet";
    LengthUnits["MILES"] = "Miles";
    LengthUnits["METERS"] = "Meters";
    LengthUnits["FATHOM"] = "Fathoms";
    LengthUnits["KILOMETERS"] = "Kilometers";
    LengthUnits["NAUTICAL_MILE"] = "Nautical Miles";
})(LengthUnits || (LengthUnits = {}));
export var ShortLengthUnit;
(function (ShortLengthUnit) {
    ShortLengthUnit["FtString"] = "ft";
    ShortLengthUnit["MiString"] = "mi";
    ShortLengthUnit["MtString"] = "m";
    ShortLengthUnit["KmString"] = "km";
    ShortLengthUnit["NmString"] = "nm";
    ShortLengthUnit["FathString"] = "ftm";
})(ShortLengthUnit || (ShortLengthUnit = {}));
export var SpeedUnits;
(function (SpeedUnits) {
    SpeedUnits["MPH"] = "MPH";
    SpeedUnits["KPH"] = "KPH";
    SpeedUnits["KNOT"] = "Knots";
})(SpeedUnits || (SpeedUnits = {}));
export var VolumeUnits;
(function (VolumeUnits) {
    VolumeUnits["GALLONS"] = "Gallons";
    VolumeUnits["LITERS"] = "Liters";
})(VolumeUnits || (VolumeUnits = {}));
export var ShortVolumeUnits;
(function (ShortVolumeUnits) {
    ShortVolumeUnits["GalString"] = "gal";
    ShortVolumeUnits["LString"] = "L";
    ShortVolumeUnits["GPHString"] = "GPH";
    ShortVolumeUnits["LPHString"] = "LPH";
})(ShortVolumeUnits || (ShortVolumeUnits = {}));
export var TemperatureUnits;
(function (TemperatureUnits) {
    TemperatureUnits["CELSIUS"] = "Celsius";
    TemperatureUnits["FAHRENHEIT"] = "Fahrenheit";
})(TemperatureUnits || (TemperatureUnits = {}));
export var CoordinatesFormats;
(function (CoordinatesFormats) {
    CoordinatesFormats["DD"] = "DD";
    CoordinatesFormats["DDM"] = "DDM";
    CoordinatesFormats["DMS"] = "DMS";
})(CoordinatesFormats || (CoordinatesFormats = {}));
//# sourceMappingURL=types.js.map